const UNITS: Array<{ unit: Intl.RelativeTimeFormatUnit; seconds: number }> = [
    { unit: 'year', seconds: 31536000 },
    { unit: 'month', seconds: 2592000 },
    { unit: 'week', seconds: 604800 },
    { unit: 'day', seconds: 86400 },
    { unit: 'hour', seconds: 3600 },
    { unit: 'minute', seconds: 60 },
]

/**
 * "5 months ago" / "vor 5 Monaten", localized via Intl. Uses the largest unit
 * that fits, "now" for anything under a minute.
 */
export const formatRelativeTime = (date: Date, locale: string, now: Date = new Date()): string => {
    const diffSeconds = (date.getTime() - now.getTime()) / 1000

    const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

    for (const { unit, seconds } of UNITS) {
        if (Math.abs(diffSeconds) >= seconds) {
            return formatter.format(Math.round(diffSeconds / seconds), unit)
        }
    }

    return formatter.format(0, 'second')
}
